import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./DashboardPage.css";

const DashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isDev = window.location.hostname === "localhost"; // או בדיקה לפי NODE_ENV אם אתה מעביר אותו ל-React

    if (!token && !isDev) {
      console.warn("⛔ אין טוקן (בפרודקשן) - מפנה להתחברות");
      navigate("/moralandamirlo");
    } else if (!token && isDev) {
      console.log("🛠️ מצב פיתוח - גישה חופשית ללא התחברות");
    }
  }, [navigate]);

  const user = JSON.parse(localStorage.getItem("user"));

  return (
<div className="DashboardPage_container">
  <h1 className="DashboardPage_title">
   {user?.username || "מנהל"} 
  </h1>

  <p className="DashboardPage_description">
    דשבורד ניהול
  </p>

  <button
    className="DashboardPage_buttonAddTaxi"
    onClick={() => window.location.href = '/dashboard/AddTaxiForSaleDashPage'}
  >
    הוספת מונית חדשה
  </button>

  <button
    className="DashboardPage_buttonAllTaxi"
    onClick={() => window.location.href = '/dashboard/AllTaxiTableDash'}
  >
    טבלת כל המוניות
  </button>

  <button
    className="DashboardPage_buttonTasks"
    onClick={() => window.location.href = '/dashboard/AddTasksForBuyTaxiDash'}
  >
    משימות
  </button>

  <button
    className="DashboardPage_buttonClients"
    onClick={() => window.location.href = '/dashboard/ContactPageDash'}
  >
    טבלה לקוחות
  </button>

  <button
    className="DashboardPage_buttonPublicRights"
    onClick={() => window.location.href = '/dashboard/NumberTaxiDashPage'}
  >
    זכויות ציבוריות
  </button>

    <button
    className="DashboardPage_buttonPublicRights"
    onClick={() => window.location.href = '/dashboard/FacebookAutoControl'}
  >
 אוטומציית פייסבוק
  </button>
      <button
    className="DashboardPage_buttonPublicRights"
    onClick={() => window.location.href = '/dashboard/BlogsDash'}
  >
עמוד מאמרים
  </button>
  
  <button
    className="DashboardPage_buttonPublicRights"
    onClick={() => window.location.href = '/dashboard/CosumtersProductsDashPage'}
  >
מוצרים
  </button>
</div>

    
  );
};

export default DashboardPage;
